import { createRouter, createWebHistory } from 'vue-router'
import Home from './components/HomePage.vue'
import Detail from './components/GoodsDetail.vue'
import DingdanPage from './components/DingdanPage.vue'
const routes = [
    {
        path: '/',
        name: 'Home', 
        component: Home,
        meta: {
            keepAlive: true,
            title: 'PUBG选号网'
        }
    },
    { 
      path: '/detail', 
      name: 'Detail',
      component: Detail,
      meta: {
        title: '账号详情'
      }
     },
     { 
      path: '/dingdan', 
      name: 'DingdanPage',
      component: DingdanPage,
      meta: {
        title: '订单详情'
      }
     },
]

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHistory('/pc3/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 返回页面时恢复滚动位置
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router